'use strict';

(() => {
  const scrollRail = (rail, direction) => {
    const isRtl = document.documentElement.dir === 'rtl';
    const maxScroll = Math.max(rail.scrollWidth - rail.clientWidth, 0);
    const currentScroll = isRtl ? -rail.scrollLeft : rail.scrollLeft;
    const distance = Math.max(rail.clientWidth * 0.72, 160);
    const atStart = currentScroll <= 2;
    const atEnd = currentScroll >= maxScroll - 2;
    let targetScroll;

    if (direction > 0) {
      targetScroll = atEnd
        ? 0
        : Math.min(currentScroll + distance, maxScroll);
    } else {
      targetScroll = atStart
        ? maxScroll
        : Math.max(currentScroll - distance, 0);
    }

    rail.scrollTo({
      left: isRtl ? -targetScroll : targetScroll,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  };

  document.querySelectorAll('[data-home-school-bundle]').forEach((bundle) => {
    const rail = bundle.querySelector('[data-home-school-rail]');
    if (!rail) return;

    bundle.addEventListener('click', (event) => {
      const button = event.target.closest('[data-school-scroll]');
      if (!button) return;

      const direction = button.dataset.schoolScroll === 'next' ? 1 : -1;
      scrollRail(rail, direction);
    });
  });
})();
